<!-- 
	Settings
	role: User
  Settings page to allow user to update account information or link to change password or optout request
-->

<template>
  <div class="settings text-white">
    <div v-if="user.loggedIn === true">
	  <div class="flex flex-col mx-auto lg:flex-row gap-8">
        <div class="flex flex-col gap-4 lg:w-1/8">
          <Badge :user="user" />
        </div>
        <div class="sm:w-100 lg:w-3/4 grow">
          <router-view :user="user" />
        </div>
        <div class="flex flex-col gap-8 grow-0 lg:w-1/8">
          <!-- Current ticket packages -->
          <div class="mb-4">
            <current-ticket-packages />
          </div>
		  
          <div class="mb-4">
            <update-ticket-packages-link-card v-if="isCurrentlyEnrolled" />
          </div>
          <div class="mb-4">
            <UpcomingDeduction :next-pay-period="nextPayPeriod" />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      NO USER
    </div>
  </div>
</template>

<script>
	import { mapGetters } from "vuex";

	import UpdateOptinFormNew from "@/components/UpdateFormNew";
	import UpdateFormTickets from "@/components/UpdateFormTickets";
	import CustomButton from "@/components/CustomButton";
	import Badge from "@/components/Badge";
	import BadgeFifty from "@/components/BadgeFifty";
import CurrentTicketPackages from '@/components/CurrentTicketPackages';
import UpcomingDeduction from '../components/UpcomingDeduction';
import UpdateTicketPackagesLinkCard from "../components/UpdateTicketPackagesLinkCard";
import { getUserPayPeriod } from "@/utils/api";

	export default {
		name: "Settings",
		components: {
			CustomButton,
			Badge,
			BadgeFifty,
			UpdateOptinFormNew,
			UpdateFormTickets,
			CurrentTicketPackages,
			UpdateTicketPackagesLinkCard,
UpcomingDeduction
		},
		data() {
			return {
				payperiods: null,
				nextPayPeriod: null,
			};
		},
		computed: {
			...mapGetters({
				user: "user",
			}),
			isCurrentlyEnrolled() {
				return this.user?.apiData?.Profile?.Year2022 && !this.user?.apiData?.Profile?.Year2022OptOut
			}
		},
		async mounted() {
			try {
				await this.loadUserPayPeriods(this.user.token, this.user.apiData.UserId)
				
			} catch (err) {
				console.log(err);
			}
		},
		methods: {
			loadUserPayPeriods: async function(token, userId) {
				const that = this;
				const payPeriodRes = await getUserPayPeriod(token, userId);
				if (payPeriodRes.Success) {
					that.payperiods = payPeriodRes.Data
					that.processPayPeriods()
				}
			},
			processPayPeriods() {
				const that = this
				var payperiods = this.payperiods;

				const today = new Date();

				const upcomingPayPeriods = payperiods.filter(x=>new Date(x.PayPeriodDate) > today);
				if (upcomingPayPeriods.length > 0) {
					that.nextPayPeriod = upcomingPayPeriods[0]
				}

				
			}
		}
	};
</script>
<style lang="scss" scoped>
	.badge {
		margin: 25px 0;
		max-width: 295px;
	}
</style>
